import { SVGInstance } from "../../../browser/instance/SVGInstance.js";
export class Color extends SVGInstance {
    color(color) {
        if (typeof color === "undefined") {
            const color = this.attr("color");
            return typeof color === "string" ? color : null;
        }
        else if (typeof color === "string") {
            this.attr("color", color);
            return this;
        }
        return null;
    }
}
//# sourceMappingURL=color.js.map